<template>
  <v-date-picker v-model="date" scrollable>
    <v-spacer />
    <v-btn text color="secondary" @click="cancel">CANCELAR</v-btn>
    <v-btn text color="primary" @click="$emit('input', date)">OK</v-btn>
  </v-date-picker>
</template>

<script>
import _ from "lodash";
export default {
  props: ["value"],
  data() {
    return {
      date: _.clone(this.value)
    };
  },
  methods: {
    cancel() {
      this.date = _.clone(this.value);
      this.$emit("input", this.value);
    }
  },
  watch: {
    value(val) {
      this.date = _.clone(val);
    }
  }
};
</script>